export default {
  'menu.system': 'Gerenciamento do Sistema',
  'menu.system.user': 'Gerenciamento de Usuários',
  'menu.system.role': 'Gerenciamento de Funções',
  'menu.system.menu': 'Gerenciamento de Menus',
  'menu.system.dept': 'Gerenciamento de Departamentos',
  'menu.monitor': 'Monitoramento',
  'menu.monitor.login-log': 'Log de Login',
  'menu.monitor.oper-log': 'Log de Operações',
  'menu.login': 'Entrar',
};
